import { takeLatest, all, put } from 'redux-saga/effects';
import Actions from "../action";
import { doGet } from '../../service/index';
import END_POINTS from './EndPoints';
import { HOSTEL_DASHBOARD, HOSTEL_DASHBOARD_DETAILS } from '../action/HostelDashboardAction';

export function* hostelDashboardSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.HOSTEL_DASHBOARD_API, params)
        yield put(Actions.hostelDashboardSuccessAction(response));
        if (callback) {
            callback(response)
        }
    } catch (error) {
        yield put(Actions.hostelDashboardFailureAction({ error }));
        if (callback) {
            callback(error)
        }
    }
}

export function* hostelDashboardDetailsSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.HOSTEL_DASHBOARD_DETAILS_API, params);
        if (callback) {
            callback(response);
        }
    } catch (error) {
        if (callback) {
            callback({ status_code: 1, message: error?.message || 'Failed to fetch details', response: [] });
        }
    }
}

export default function* hostelDashboardWatcher() {
    yield all([
        takeLatest(HOSTEL_DASHBOARD, hostelDashboardSaga),
        takeLatest(HOSTEL_DASHBOARD_DETAILS, hostelDashboardDetailsSaga),
    ]);
}